import React from 'react';
import { useLocation, useParams } from 'react-router';
import RisResultsTable from 'routes/surface/components/node-modal-form/components/ris-search-modal/components/ris-search-results/components/ris-results-table';
import If from 'components/if-statement';
import RisDocumentNodeForm from 'routes/surface/components/node-modal-form/components/ris-search-modal/components/ris-document-node-form';
import { ModalContext } from 'hoc/with-modal';
import {
  SurfaceDocumentNode,
  SurfaceDocumentNodeFormat,
  SurfaceNodeType,
} from 'graphql/types';
import { NodeModalInput } from 'types';
import { useHistory } from 'react-router-dom';

export interface RisSearchResultProps {
  filter: { type: string; search: string };
  modal: ModalContext;
  data: NodeModalInput<SurfaceDocumentNode>;
  showSearchForm: Function;
  setFilter: Function;
}

function RisSearchResult({
  filter,
  modal,
  data,
  ...props
}: RisSearchResultProps) {
  const { id: surface } = useParams();
  const [risNode, setRisNode] = React.useState<any>();

  const history = useHistory();

  const location = useLocation();

  React.useEffect(() => {
    return () => {
      history.replace(location.pathname);
    };
  }, []);

  function showRisNodeForm(risData) {
    setRisNode({
      type: SurfaceNodeType.Document,
      name: getDocumentName(risData),
      url: risData?.url,
      format: SurfaceDocumentNodeFormat.Pdf,
      file: risData?.url,
    });
  }

  function getDocumentName(risData) {
    if (risData?.lawName) {
      return `${risData?.id} ${risData?.lawName}`;
    }
    return risData?.id;
  }

  function backToResults() {
    return setRisNode(undefined);
  }

  const initialValues = {
    id: '',
    format: risNode?.format,
    fromRis: true,
    position: data.position,
    surface: surface as string,
    name: risNode?.name,
    url: risNode?.url,
  } as any;

  return (
    <If condition={risNode}>
      <If.Then>
        <RisDocumentNodeForm
          modal={modal}
          initialValues={initialValues}
          backToResults={backToResults}
        />
      </If.Then>
      <If.Else>
        <RisResultsTable
          showRisNodeForm={showRisNodeForm}
          showSearchForm={props.showSearchForm}
          filter={filter}
          setFilter={props.setFilter}
          modal={modal}
        />
      </If.Else>
    </If>
  );
}

export default RisSearchResult;
